export default __webpack_public_path__ + "static/media/icn_trend_analysis.51868487.svg";